import React from 'react';
import {MAX_FILE_SIZE_IN_MB} from '../constants';

const date = new Date();

// Validation error messages
export const fieldIsRequired = 'This field is required';
export const emailIdInvalid = 'Is not a valid email address';
export const passwordDoesNotMatch = 'Password does not match retyped password';
export const retypedPasswordDoesNotMatch = 'Retyped password does not match the password';
export const passwordNoEmpty = 'Password cannot be empty';
export const passwordChanged = 'Password has been changed';
export const confirmPasswordNoEmpty = 'Confirm password cannot be empty';
export const accetPrivacyPolicy = 'Please read the Terms of Use and Privacy Policy and make sure you agree with it.';
export const noSpacesErrorMessage = type => `${type} can't contain spaces`;
export const nolessErrorMessage = (type, length) => `${type} cannot be less than ${length} characters`;
export const nolongerErrorMessage = (type, length) => `${type} cannot be longer than ${length} characters`;
export const noImageSelected = 'Drop a file here or click to upload.';
export const imageExtensions = '(only .JPG, .PNG, .GIF)';

export const adminPopoverTitle = 'Start the game!';
export const othersPopoverTitle = 'Click "Ready" to play...';
export const adminPopoverMessage = 'Click "Start Game" when all players are ready.';
export const othersPopoverMessage = 'Waiting for all players to click Ready.';
export const giftToastMessage = 'Click on a player and send them a gift!';
export const kickToastMessage = 'You can vote to kick a player out for inappropriate conduct';
export const youKickedMessage = 'You’ve been kicked from the game!';
export const youCantJoinMessage = 'You can’t join this game. It has already started.';
export const youCantJoinFullGameMessage = 'You can’t join this game since it’s already full.';

export const fileTypeNotSupportedError = 'This file type is not supported.';
export const fileSizeExceedError = `This file is too large! Please upload file up to ${MAX_FILE_SIZE_IN_MB}MB.`;
export const userPasswordChanged = 'Password has been changed';
export const userProfileUpdated = 'Profile successfully updated';
export const noDataToDisplay = 'No data to display';
export const treasureRedeemedMessage = (
  <span>
    Your request has been sent!
    <br/>
    <small>An email confirmation will be sent to you.</small>
  </span>
);
// Content text
export const gameLeaveMessage = 'Are you sure you want to leave this page. You can return to the game from the Lobby.';
export const gameLeaveWithRemoveMessage = 'You are about to leave this page. Leaving now will remove you from the game.';
export const gameKickConfirmMessage = 'To kick a player out of the game vote Yes or No. \n'
  + 'The player won’t be allowed to return.';

export const winFinishMessage = ({name}) => `Team ${name} wins!`;
export const tieFinishMessage = () => 'It’s a tie!';

export const redemptionLoadingError = 'Redemption cannot be loaded';
export const redemptionApprovedMessage = 'You approved this redemption';
export const redemptionRejectedMessage = 'You rejected this redemption';

export const footerCopyright = `© 2012-${date.getFullYear()} Yak Network, LLC. — Patent # US 9636,572,132`;

export const microphonesMutedMessage = 'Microphones are muted during video';

export const browserListTitle = browserCount => `Use ${browserCount === 1 ? 'this browser' : 'these browsers'} … or newer`;

export const upgradeBrowserPanelTitle = 'Please download another browser';
export const upgradeBrowserPanelSubTitle = 'To play Yak, you need to play on a Tablet or a Desktop browser';
export const rejoinAPIWarning = 'You are already in the game from another browser tab or device';
